/** 部署在子路径时的前缀（vite `base`；根路径部署为空串）。
 *
 * 常规部署 base 为 `/`；dev 环境挂在 `/hilstabilityserver/simulation-platform` 这类前缀下，
 * 构建时用 `vite build --base=/hilstabilityserver/simulation-platform/`，
 * 路由 basename 与硬跳转都由这里统一取用，避免各处再写死前缀。
 */
export const BASE_PATH = import.meta.env.BASE_URL.replace(/\/+$/, '');

/** 把根相对路径接到部署前缀上（只给 `window.location` 这类硬跳转用；路由跳转走 basename）。 */
export const withBasePath = (path: string) =>
  `${BASE_PATH}${path.startsWith('/') ? path : `/${path}`}`;